<div class="error-page-container">
  <div class="content">
    <h1 class="error-code">403</h1>
    <h2 class="error-title">No Permission</h2>
    <p class="error-message">
      You do not have permission to access this resource.
    </p>

    <button (click)="goHome()" class="btn-primary-action">Back to home</button>
  </div>
</div>
